import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Spinner,
  Button,
  ButtonGroup,
  Form,
} from "react-bootstrap";
import dayjs from "dayjs";
import NavBar from "../../Components/NavBar";
import AppComponent from "../../../Components/AppComponent";
import api from "../../../Services/Api/api";
import { impersonate } from "../../../Modules/auth/startup";
import DateRangeFilter from "../../Components/DateRangeFilter";

class HeadOfficeOverviewV2 extends AppComponent {
  state = {
    loading: true,
    error: null,
    summary: null,
    startDate: null,
    endDate: null,
    filterType: "salary_cycle",
  };

  componentDidMount() {}

  async loadData() {
    const { startDate, endDate } = this.state;

    try {
      this.setState({ loading: true, error: null });

      const response = await api.get("v1/head-office/summary/overview", {
        startDate,
        endDate,
      });

      this.setState({
        summary: response.summary,
        loading: false,
      });
    } catch (err) {
      this.setState({
        error: err.message || "Failed to load dashboard",
        loading: false,
      });
    }
  }

  setRange = (type) => {
    let start = dayjs();
    let end = dayjs();

    if (type === "yesterday") {
      start = dayjs().subtract(1, "day");
      end = start;
    }

    this.setState(
      {
        filterType: type,
        startDate: start.format("YYYY-MM-DD"),
        endDate: end.format("YYYY-MM-DD"),
      },
      () => this.loadData()
    );
  };

  renderStat(label, value, variant = "primary") {
    return (
      <Card className="text-center shadow-sm h-100">
        <Card.Body>
          <div className="text-muted small">{label}</div>
          <div className={`fw-bold h5 text-${variant}`}>
            {value.toLocaleString("en-IN")}
          </div>
        </Card.Body>
      </Card>
    );
  }

  renderHeadOfficeCard(office) {
    return (
      <Col key={office.officeId} md={6} lg={4} className="mb-4">
        <Card className="shadow-sm h-100">
          <Card.Body className="small">
            <h6 className="fw-bold mb-2">{office.officeName}</h6>

            {/* ================= OPERATIONS ================= */}
            <Row className="text-center mb-2">
              <Row className="mb-1">
                <Col>Salary Expense</Col>
                <Col className="text-end text-danger">
                  − ₹ {office.salaryExpense.toLocaleString("en-IN")}
                </Col>
              </Row>

              <Row className="mb-1">
                <Col>Office Expense</Col>
                <Col className="text-end text-danger">
                  − ₹ {office.officeExpense.toLocaleString("en-IN")}
                </Col>
              </Row>
              <hr className="my-1" />
              <Row className="mb-1 fw-bold">
                <Col>Total:</Col>
                <Col className="text-end text-danger">
                  − ₹{" "}
                  {(
                    Number(office.officeExpense) + Number(office.salaryExpense)
                  ).toLocaleString("en-IN")}
                </Col>
              </Row>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    );
  }

  renderOfficeCard(office) {
    return (
      <Col key={office.officeId} md={6} lg={4} className="mb-4">
        <Card className="shadow-sm h-100">
          <Card.Body className="small">
            <Button
              size="sm"
              variant="outline-secondary"
              className="float-end"
              onClick={() => impersonate(office.officeId)}
            >
              Login
            </Button>

            <h6 className="fw-bold mb-2">{office.officeName}</h6>

            {/* ================= OPERATIONS ================= */}
            <Row className="text-center mb-2">
              <Col xs={4}>
                <div className="text-muted">Pickup</div>
                <div className="fw-semibold">
                  {office.pickupCount.toLocaleString("en-IN")}
                </div>
              </Col>
              <Col xs={4}>
                <div className="text-muted">Delivery</div>
                <div className="fw-semibold">
                  {office.deliveryCount.toLocaleString("en-IN")}
                </div>
              </Col>
              <Col xs={4}>
                <div className="text-muted">Parcels</div>
                <div className="fw-semibold">
                  {office.totalParcels.toLocaleString("en-IN")}
                </div>
              </Col>
            </Row>

            <hr className="my-2" />

            {/* ================= USER MONEY ================= */}
            <div className="text-muted fw-semibold mb-1">User / FE Balance</div>
            <Row className="text-center mb-2">
              <Col xs={6}>
                <div className="text-muted">User Due</div>
                <div className="fw-semibold text-danger">
                  ₹ {office.totalUserBalanceDue.toLocaleString("en-IN")}
                </div>
              </Col>
              <Col xs={6}>
                <div className="text-muted">Commission</div>
                <div className="fw-semibold text-warning">
                  ₹ {office.totalCommissionBalance.toLocaleString("en-IN")}
                </div>
              </Col>
            </Row>

            {/* ================= OFFICE MONEY ================= */}
            <div className="text-muted fw-semibold mb-1">Office Balance</div>
            <Row className="text-center">
              <Col xs={4}>
                <div className="text-muted">Cash</div>
                <div className="fw-semibold">
                  ₹ {office.cashBalance.toLocaleString("en-IN")}
                </div>
              </Col>
              <Col xs={4}>
                <div className="text-muted">Online</div>
                <div className="fw-semibold">
                  ₹ {office.onlineBalance.toLocaleString("en-IN")}
                </div>
              </Col>
              <Col xs={4}>
                <div className="text-muted fw-bold">Total</div>
                <div className="fw-bold text-success">
                  ₹ {office.totalBalance.toLocaleString("en-IN")}
                </div>
              </Col>
            </Row>

            <hr className="my-2" />

            {/* ================= PROFIT CALC ================= */}
            <Row className="mb-1">
              <Col>Vendor Revenue</Col>
              <Col className="text-end fw-semibold text-primary">
                ₹ {office.vendorRevenue.toLocaleString("en-IN")}
              </Col>
            </Row>

            <Row className="mb-1">
              <Col>FE Cost</Col>
              <Col className="text-end text-warning">
                − ₹ {office.feCost.toLocaleString("en-IN")}
              </Col>
            </Row>

            <Row className="fw-semibold">
              <Col>Gross Margin</Col>
              <Col className="text-end">
                ₹ {office.grossMargin.toLocaleString("en-IN")}
              </Col>
            </Row>

            <div className="text-muted small mb-2">
              (Before salary & office expenses)
            </div>
            {office.salaryExpense ? (
              <Row className="mb-1">
                <Col>Salary Expense</Col>
                <Col className="text-end text-danger">
                  − ₹ {office.salaryExpense.toLocaleString("en-IN")}
                </Col>
              </Row>
            ) : null}

            <Row className="mb-1">
              <Col>Office Expense</Col>
              <Col className="text-end text-danger">
                − ₹ {office.officeExpense.toLocaleString("en-IN")}
              </Col>
            </Row>

            <hr className="my-2" />

            <Row className="fw-bold">
              <Col>Net Profit</Col>
              <Col
                className={`text-end ${
                  office.netProfit >= 0 ? "text-success" : "text-danger"
                }`}
              >
                ₹ {office.netProfit.toLocaleString("en-IN")}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    );
  }

  renderTotalStat(label, value, variant, size = "md") {
    const sizeClass = size === "lg" ? "display-6 fw-bold" : "h6 fw-semibold";

    return (
      <Card className="shadow-sm text-center h-100">
        <Card.Body>
          <div className="text-muted small mb-1">{label}</div>
          <div className={`${sizeClass} text-${variant}`}>
            ₹ {value.toLocaleString("en-IN")}
          </div>
        </Card.Body>
      </Card>
    );
  }

  render() {
    const { loading, error, summary, startDate, endDate, filterType } =
      this.state;

    const bussinessVol = (
      <Card className="shadow-sm h-100 mb-2">
        <Card.Body>
          <h6 className="fw-bold mb-3 text-primary">
            Business Volume (For Selected Period)
          </h6>

          <Row className="mb-2">
            <Col>Pickup Count</Col>
            <Col className="text-end fw-semibold">
              {summary?.total.pickupCount.toLocaleString("en-IN")}
            </Col>
          </Row>

          <Row className="mb-2">
            <Col>Delivery Count</Col>
            <Col className="text-end fw-semibold">
              {summary?.total.deliveryCount.toLocaleString("en-IN")}
            </Col>
          </Row>

          <hr className="my-2" />

          <Row>
            <Col className="fw-semibold">Total Parcels</Col>
            <Col className="text-end fw-bold">
              {summary?.total.totalParcels.toLocaleString("en-IN")}
            </Col>
          </Row>

          <div className="text-muted small mt-2">
            (Total pickup + delivery handled in this period)
          </div>
        </Card.Body>
      </Card>
    );

    const moneyPos = (
      <Card className="shadow-sm h-100">
        <Card.Body>
          <h6 className="fw-bold mb-3 text-secondary">
            Money Position (As of Selected Date)
          </h6>

          <Row className="mb-2">
            <Col>User Balance Due</Col>
            <Col className="text-end fw-semibold text-danger">
              ₹ {summary?.total.totalUserBalanceDue.toLocaleString("en-IN")}
            </Col>
          </Row>
          <div className="text-muted small mb-2">
            (Total amount payable by users to the office)
          </div>

          <Row className="mb-2">
            <Col>Commission Balance</Col>
            <Col className="text-end fw-semibold text-info">
              ₹ {summary?.total.totalCommissionBalance.toLocaleString("en-IN")}
            </Col>
          </Row>
          <div className="text-muted small mb-2">
            (Unsettled commission balance of field executives)
          </div>

          <Row className="mb-2">
            <Col>Office Balance</Col>
            <Col className="text-end fw-semibold text-success">
              ₹ {summary?.total.totalBalance.toLocaleString("en-IN")}
            </Col>
          </Row>
          <div className="text-muted small">
            (Actual cash + online balance available)
          </div>
        </Card.Body>
      </Card>
    );

    const profitCalc = (
      <Card className="shadow-sm h-100 mb-2">
        <Card.Body>
          <h6 className="fw-bold mb-3 text-success">
            Profit Calculation (For Selected Period)
          </h6>

          <Row className="mb-2">
            <Col>Vendor Revenue</Col>
            <Col className="text-end fw-semibold text-primary">
              ₹ {summary?.total.vendorRevenue.toLocaleString("en-IN")}
            </Col>
          </Row>

          <Row className="mb-2">
            <Col>FE Cost</Col>
            <Col className="text-end fw-semibold text-warning">
              − ₹ {summary?.total.feCost.toLocaleString("en-IN")}
            </Col>
          </Row>

          <hr className="my-2" />

          <Row className="mb-2">
            <Col className="fw-semibold">Gross Margin</Col>
            <Col className="text-end fw-bold">
              ₹ {summary?.total.grossMargin.toLocaleString("en-IN")}
            </Col>
          </Row>

          <div className="text-muted small mb-2">
            (Earnings before salary and office expenses)
          </div>

          <Row className="mb-2">
            <Col>Salary Expense</Col>
            <Col className="text-end fw-semibold text-danger">
              − ₹ {summary?.total.salaryExpense.toLocaleString("en-IN")}
            </Col>
          </Row>

          <Row className="mb-2">
            <Col>Office Expense</Col>
            <Col className="text-end fw-semibold text-danger">
              − ₹ {summary?.total.officeExpense.toLocaleString("en-IN")}
            </Col>
          </Row>

          <hr className="my-2" />

          <Row className="mb-2">
            <Col className="fw-semibold">Total Expense</Col>
            <Col className="text-end fw-semibold">
              ₹{" "}
              {(
                summary?.total.feCost +
                summary?.total.salaryExpense +
                summary?.total.officeExpense
              ).toLocaleString("en-IN")}
            </Col>
          </Row>

          <hr className="my-2" />

          <Row>
            <Col className="fw-bold">Net Profit</Col>
            <Col
              className={`text-end fw-bold ${
                summary?.total.netProfit >= 0 ? "text-success" : "text-danger"
              }`}
            >
              ₹ {summary?.total.netProfit.toLocaleString("en-IN")}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );

    return (
      <>
        <NavBar />
        <Container
          fluid
          className="py-4"
          style={{ backgroundColor: "aliceblue" }}
        >
          <h4 className="fw-bold text-center mb-3">Head Office Overview</h4>

          <Card className="text-nowrap pb-0 p-2 mb-2 ">
            <div
              style={{
                fontSize: "11px",
                color: "gray",
                textAlign: "center",
              }}
            >
              Date Range Filter
            </div>
            {/* ===== Header (Mobile Friendly) ===== */}

            <DateRangeFilter
              filterType={filterType}
              startDate={startDate}
              endDate={endDate}
              onChange={({ filterType, start: startDate, end: endDate }) => {
                this.setState({ filterType, startDate, endDate }, () =>
                  this.loadData({})
                );
              }}
            />
          </Card>

          {loading && (
            <div
              className="d-flex w-100 justify-content-center align-items-center"
              style={{ height: "100px" }}
            >
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          )}
          {error && <div className="text-danger">{error}</div>}

          {!loading && summary && (
            <>
              <Row className="mb-4 g-3 align-items-stretch">
                <Col md={6} className="d-flex">
                  <div className="flex-fill">{profitCalc}</div>
                </Col>

                <Col md={6}>
                  <Row className="g-3">
                    <Col xs={12}>{bussinessVol}</Col>
                    <Col xs={12}>{moneyPos}</Col>
                  </Row>
                </Col>
              </Row>

              {/* HEAD OFFICE */}
              {summary?.headOffice && (
                <>
                  <h6 className="fw-semibold mb-2">Head Office</h6>
                  <Row>
                    {this.renderHeadOfficeCard(summary?.headOffice, true)}
                  </Row>
                </>
              )}
              {/* OFFICES */}
              <h6 className="fw-semibold mt-4 mb-2">Offices</h6>
              <Row>{summary?.offices.map((o) => this.renderOfficeCard(o))}</Row>
            </>
          )}
        </Container>
      </>
    );
  }
}

export default HeadOfficeOverviewV2;
